// extracted by mini-css-extract-plugin
export default {"MessageBox":"Nachrichtenauftraege_MessageBox__9-xbj"};